import { useMutation, useQuery } from '@tanstack/react-query';
import { getPrivateAxiosInstance } from '../../../axiosInstances/axiosPrivate';
import { AcademiaResponse } from '../../../types/common';
import {
  TransactionHistory,
  TransactionHistoryReqBody,
} from '../../../types/history';
import { returnQueryConfig } from '../../../utils/commonFunctions';

const useTransactionActions = (whichAction: 'transactionList' | '') => {
  // query function to fetch all the transactions declared here
  const getTransactionListHandler = useQuery({
    queryKey: ['transaction-list'],
    queryFn: async (): Promise<AcademiaResponse<Array<TransactionHistory>>> => {
      const response = await getPrivateAxiosInstance('finance').get(
        '/credit/transaction/list/'
      );

      return response.data;
    },

    ...returnQueryConfig(whichAction === 'transactionList'),
  });

  // mutation function to create new transaction declared here
  const createNewTransactionHandler = useMutation({
    mutationFn: async ({
      body,
    }: {
      body: TransactionHistoryReqBody;
    }): Promise<AcademiaResponse<TransactionHistory>> => {
      const response = await getPrivateAxiosInstance('finance').post(
        '/credit/transaction/create/',
        body
      );

      return response.data;
    },
  });

  return { getTransactionListHandler, createNewTransactionHandler };
};

export default useTransactionActions;
